import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Contact\GetContactByIdController::__invoke
* @see app/Http/Controllers/Contact/GetContactByIdController.php
* @route '/api/contact/{mergeableContact}'
*/
const GetContactByIdController = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetContactByIdController.url(args, options),
    method: 'get',
})

GetContactByIdController.definition = {
    methods: ["get","head"],
    url: '/api/contact/{mergeableContact}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Contact\GetContactByIdController::__invoke
* @see app/Http/Controllers/Contact/GetContactByIdController.php
* @route '/api/contact/{mergeableContact}'
*/
GetContactByIdController.url = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mergeableContact: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { mergeableContact: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            mergeableContact: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mergeableContact: typeof args.mergeableContact === 'object'
        ? args.mergeableContact.id
        : args.mergeableContact,
    }

    return GetContactByIdController.definition.url
            .replace('{mergeableContact}', parsedArgs.mergeableContact.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Contact\GetContactByIdController::__invoke
* @see app/Http/Controllers/Contact/GetContactByIdController.php
* @route '/api/contact/{mergeableContact}'
*/
GetContactByIdController.get = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetContactByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Contact\GetContactByIdController::__invoke
* @see app/Http/Controllers/Contact/GetContactByIdController.php
* @route '/api/contact/{mergeableContact}'
*/
GetContactByIdController.head = (args: { mergeableContact: string | number | { id: string | number } } | [mergeableContact: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetContactByIdController.url(args, options),
    method: 'head',
})

export default GetContactByIdController